import axios from 'axios'
import store from '@/store'
import router from '@/router'
import storage from 'good-storage';

import qs from 'qs'


const httpUtil = axios.create({
  baseURL: 'http://' + process.env.API_ROOT, // 配置文件中统一配置的后台接口请求路径,不需要再具体的业务代码中多次重复
  timeout: 50000
})

// const http = http
// http.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';


/**
 * 请求拦截器
 **/ 
httpUtil.interceptors.request.use(
  config => {
    const meta = (config.meta || {});

    if (!config.data.timestamp) {
      config.data.timestamp = new Date().getTime().toString();
    }

    // 所有请求接口安全权限控制 start
    // 对于所有的非 /login(登录) 接口进行 application/json 的方式进行数据提交; 
    // 登录接口接口仍旧使用 form表单的方式进行提交.(因为兼容基于老框架升级而来的shiro权限认证,暂时必须使用form表单的方式进行提交).
    // 正常的前后端分离框架是不需要对登录接口使用form表单的方式
    if (config.url !== '/login') {
      config.headers.post['Content-Type'] = 'application/json;charset=utf-8';
      //headers中配置serialize为true开启序列化
      if (config.method === 'post' && meta.isSerialize === true) {
        config.data = serialize(config.data);
      }
    } else {
      config.data = qs.stringify(config.data);
    }

    // 对所有的非login接口添加token, 在http请求的头部添加 Authorization 属性,并将存在storage中的token信息带上.
    if (storage.session.get('Authorization') && config.url != '/login') {
      config.headers['Authorization'] = storage.session.get('Authorization');
    }

    return config;
  },
  function (error) {
    return Promise.reject(error);
  })
/**
 * 响应拦截器
 **/
httpUtil.interceptors.response.use(function (response) {

  let res = response.data;
  // 后台请求接口状态 200 表示成功
  if (response.status == '200') {

    // 在此统一对401进行处理, 后台接口返回的401代码, 为权限认证失败, 需要重新确定到登录页面
    if (res.code == '401') {
      if (store.getters.path != '/login') {
        // MessageBox.confirm('您的操作已经超时，请重新登录！', '确认登录', {
        //   confirmButtonText: '重新登录',
        //   cancelButtonText: '关闭',
        //   // type: 'warning'
        //   type: 'error'
        // });
        // TODO: 用户
      }
      router.push({
        path: '/login'
      });

      return Promise.reject(new Error(res.message || 'Error'));
    }
  }

  return res;
}, function (error) {
  return Promise.reject(error);
})

const http = {}

/**
 * 重新封装 post 方法
 * @param url
 * @param param
 * @returns {Promise<AxiosResponse<T>>}
 */
http.post = function (url, params) {
  return httpUtil.post(url, params);
}

/**
 * 重新封装 get 方法
 * @param url
 * @param param
 * @returns {Promise<AxiosResponse<T>>}
 */
http.get = function (url, params) {
  return httpUtil.get(url, {
    params: params,
    paramsSerializer: params => {
      // return qs.stringify(params, { indices: false })
      return qs.stringify(params)
    }
  })
}

export default http;



// WEBPACK FOOTER //
// ./src/axios/http.js